import {notification} from "antd";
import {createSavedMarket} from "../utils/likedMarket/createSavedMarket";
import {deleteSavedMarket} from "../utils/likedMarket/deleteSavedMarket";

export const getHandleSaveMarket = (setMarkets) => {
    return (record) => {
        const {market_id: marketId, market_name: marketName} = record;

        if (!marketId) {
            notification.warning({
                message: "Missing Market",
                description: "Cannot save this company because its Market is missing.",
                placement: "bottomRight",
            });
            return;
        }

        createSavedMarket({marketId: marketId})
            .then(({success, message}) => {
                if (message === "Market already liked by user") {
                    notification.info({
                        message: "Already Liked",
                        description: `${marketName} is already in your saved list.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });
                } else if (success) {
                    notification.success({
                        message: "Market Added",
                        description: `${marketName} has been added to your saved list.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });

                    // ✅ Update local list
                    setMarkets((prev) =>
                        prev.map((market) =>
                            market.market_id === marketId
                                ? {...market, is_saved: true}
                                : market
                        )
                    );
                } else {
                    notification.error({
                        message: "Failed to Add",
                        description: `Could not add ${marketName}. Please try again.`,
                        placement: "bottomRight",
                        duration: 2.5,
                    });
                }
            })
            .catch((error) => {
                console.error("Error adding market:", error);
                notification.error({
                    message: "Server Error",
                    description: "Something went wrong. Try again later.",
                    placement: "bottomRight",
                    duration: 2.5,
                });
            });
    };
};

export const getHandleDeleteSaveMarket = (setMarkets, userToken) => {
    return (record, onDeleteCallback) => {
        const {market_id: marketId, market_name: marketName, id} = record;

        if (!marketId) {
            notification.warning({
                message: "Missing Market ID",
                description: "Cannot remove this market because its ID is missing.",
                placement: "bottomRight",
            });
            return;
        }

        deleteSavedMarket({marketId, token: userToken})
            .then((success) => {
                if (success) {
                    // Update local state (if needed)
                    if (setMarkets) {
                        setMarkets((prev) =>
                            prev.map((market) =>
                                market.id === id ? {...market, is_saved: false} : market
                            )
                        );
                    }

                    // Optional: Trigger UI update callback
                    if (typeof onDeleteCallback === 'function') {
                        onDeleteCallback(record);
                    }

                    notification.warning({
                        message: 'Market Removed',
                        description: `${marketName} has been removed from the list.`,
                        placement: 'bottomRight',
                        duration: 2.5,
                    });
                } else {
                    notification.error({
                        message: 'Remove Failed',
                        description: `Could not remove ${marketName}. Please try again.`,
                        placement: 'bottomRight',
                        duration: 2.5,
                    });
                }
            })
            .catch((error) => {
                notification.error({
                    message: 'Server Error',
                    description: 'Something went wrong. Try again later.',
                    placement: 'bottomRight',
                    duration: 2.5,
                });
                console.error("Error deleting company:", error);
            });
    };
};
